import { createContext, useContext, useState, useRef } from 'react';
import axios from 'axios';
import { API } from './api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const [user, setUser] = useState(null);
  const hasCheckedAuth = useRef(false);

  const checkAuth = async () => {
    // If already checked and authenticated, don't check again
    if (hasCheckedAuth.current && isAuthenticated !== null) {
      return isAuthenticated;
    }
    
    try {
      const response = await axios.get(`${API}/auth/me`, {
        withCredentials: true
      });
      setUser(response.data);
      setIsAuthenticated(true);
      hasCheckedAuth.current = true;
      return true;
    } catch (error) {
      setIsAuthenticated(false);
      hasCheckedAuth.current = true;
      return false;
    }
  };

  const login = (userData) => {
    setUser(userData);
    setIsAuthenticated(true);
    hasCheckedAuth.current = true;
  };

  const logout = async () => {
    try {
      await axios.post(`${API}/auth/logout`, {}, { withCredentials: true });
    } catch (e) {
      // Ignore logout errors
    }
    setUser(null);
    setIsAuthenticated(false);
    hasCheckedAuth.current = true;
  };

  return (
    <AuthContext.Provider value={{ 
      isAuthenticated, 
      user, 
      checkAuth, 
      login, 
      logout, 
      setUser 
    }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
